import React, { useState, useEffect } from 'react';
import { Button } from "@material-ui/core"

export default function TimeoutButton(props){
    const {children, onClick, timeout, interval, disabled, ...rest} = props

    const DEFAULT_TIMER = 10000

    const [timer, setTimer] = useState(0)
    const [isTimerStarted, setIsTimerStarted] = useState(false)
    let timerHandler = 0

    useEffect(() => {
        if(timer > 0 && !isTimerStarted){
            timerHandler = setInterval(countDown, 1000)
            setIsTimerStarted(true)
        }

        // return ()=>{
        //     clearInterval(timerHandler)
        // }
    }, [timer])

    return (
        <Button onClick={handleClick} disabled={timer > 0 || disabled} {...rest}>
            {timer <= 0 ? children : timer/1000}
        </Button>
    )

    function handleClick(){
        onClick()
        setTimer(timeout || DEFAULT_TIMER)
    }

    function countDown(){
        setTimer(prev => {
            let time = prev - 1000
            if(time === 0){
                clearInterval(timerHandler)
                setIsTimerStarted(false)
            }
            return time
        })
    }
}